module.exports = __webpack_public_path__ + "static/029-25c7f7fe2b41155899df4fa64946e968.jpg";